(function () {
    'use strict';

    angular
        .module('app')
        .controller('DashboardController', DashboardController);

    DashboardController.$inject = ['authentication', '$modal', '$timeout', '$window', '$cookies', '$state', 'config'];

    function DashboardController(authentication, $modal, $timeout, $window, $cookies, $state, config) {
        var vm = this;

        vm.isLoading = true;
        vm.isLoggedIn = false;
        vm.formError = "";
        vm.formSuccess = "";

        vm.onClickEditEmail = onClickEditEmail;
        vm.onClickEditPassword = onClickEditPassword;
        vm.onClickConnectCAC = onClickConnectCAC;
        vm.onClickRemoveCAC = onClickRemoveCAC;
        vm.onClickVerifyAccount = onClickVerifyAccount;
        vm.onClickRequestVerificationEmail = onClickRequestVerificationEmail;
        vm.onClickEnterResetToken = onClickEnterResetToken;

        activate();

        function activate() {
            if (authentication.isLoggedIn()) {
                vm.isLoggedIn = true;
                vm.email = authentication.getEmail();
                var cacInfo = authentication.getCacInfo();
                vm.cacRegistered = cacInfo.registered === "true";
                vm.cacInUse = cacInfo.inUse === "true";
            }
            else {
                vm.isLoggedIn = false;
                vm.email = null;

                // If "/verify", open Verify modal initially
                if ($state.current.name === 'accountManagement.verify') {
                    vm.onClickVerifyAccount();
                }

                if ($state.current.name === 'accountManagement.reset-password-token') {
                    vm.onClickEnterResetToken();
                }

                if ($state.current.name === 'accountManagement.request-verification-email') {
                    vm.onClickRequestVerificationEmail();
                }
            }
            vm.isLoading = false;
        }

        function onClickEditEmail() {
            $modal.open({
                templateUrl: 'app/components/dashboard/editEmail.view.html',
                controller: 'EditEmailController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false',
                resolve: {
                    email: function () {
                        return vm.email;
                    }
                }
            }).result.then(function () {
                vm.formError = '';
                vm.formSuccess = 'Email updated successfully! Logging you out...';

                $cookies.put('logged-out-reason', "Email successfully changed! Please log in again with your new credentials.");

                return emailPasswordChangeLogOut();
            });
        }

        function onClickEditPassword() {
            $modal.open({
                templateUrl: 'app/components/dashboard/editPassword.view.html',
                controller: 'EditPasswordController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false',
                resolve: {
                    isDismissible: function () {
                        return true;
                    }
                }
            }).result.then(function () {
                vm.formError = '';
                vm.formSuccess = 'Password updated successfully! Logging you out...';

                $cookies.put('logged-out-reason', "Password successfully changed! Please log in again with your new credentials.");

                return emailPasswordChangeLogOut();
            });
        }

        function onClickVerifyAccount() {
            $modal.open({
                templateUrl: 'app/components/verify/verify.view.html',
                controller: 'VerifyController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false',
                resolve: {
                    isVerifying: function () {
                        return true;
                    }
                }
            }).result.then(function () {
                vm.formError = '';
                vm.formSuccess = 'Email verified successfully!';
            });
        }

        function onClickRequestVerificationEmail() {
            $modal.open({
                templateUrl: 'app/components/verify/verify.view.html',
                controller: 'VerifyController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false',
                resolve: {
                    isVerifying: function () {
                        return false;
                    }
                }
            }).result.then(function () {
                vm.formError = '';
                vm.formSuccess = 'Verification email sent successfully!';
            });
        }

        function onClickEnterResetToken() {
            $modal.open({
                templateUrl: 'app/components/resetToken/resetToken.view.html',
                controller: 'ResetTokenController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false'
            }).result.then(function () {
                vm.formError = '';
                vm.formSuccess = 'Token accepted!';
            });
        }

        function emailPasswordChangeLogOut() {
            vm.isLoading = true;

            var ticketErrorStr = "";

            return config.get().then(function (configData) {
                ticketErrorStr = configData.loggedOutReasons.ticketError;
            })
                // This function does most of logOut() except not log out of Core API,
                // since that appears to be done by the API when changing email/password.
                // This function should change URL, so only failure should return here?
                .then(authentication.logOutCasOnly)
                .catch(function (error) {
                    console.error(error);
                    $cookies.put('logged-out-reason', ticketErrorStr);
                })
                // This shouldn't happen, but just in case, send to AM logged out page.
                .finally(function (response) {
                    $state.go('accountManagement.loggedOut');
                });
        }

        function onClickConnectCAC() {
            vm.isLoading = true;

            authentication.getCacInfoFromCard().then(function (cacInfo) {
                return authentication.getProxyTicket().then(function (response) {
                    return config.get().then(function (configData) {
                        let url = configData.casUserAdmin;

                        if (cacInfo && cacInfo.cacId && cacInfo.iv && cacInfo.subjectDN) {
                            url += 'rest/addCacWithCert'
                                + '?service=' + encodeURIComponent($window.location.href)
                                + '&pt=' + encodeURIComponent(response.proxyTicket)
                                + '&cacId=' + encodeURIComponent(cacInfo.cacId)
                                + '&subjectDN=' + encodeURIComponent(cacInfo.subjectDN)
                                + '&iv=' + encodeURIComponent(cacInfo.iv);
                        } else {
                            url += 'rest/addCac'
                                + '?service=' + encodeURIComponent($window.location.href)
                                + '&pt=' + encodeURIComponent(response.proxyTicket);
                        }

                        $window.location.href = url;
                        vm.isLoading = false;
                    });
                });
            }).catch(function (error) {
                vm.formSuccess = '';
                vm.formError = error;
                vm.isLoading = false;
            });
        }

        function onClickRemoveCAC() {
            vm.isLoading = true;
            authentication.getProxyTicket().then(function (response) {
                return config.get().then(function (configData) {
                    $window.location.href = configData.casUserAdmin + 'rest/removeCac?service=' + $window.location.href + '&pt=' + response.proxyTicket;
                    vm.isLoading = false;
                });
            }).catch(function (error) {
                vm.formSuccess = '';
                vm.formError = error;
                vm.isLoading = false;
            });
        }

    }
})();